import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { notify } from '../../../toaster';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { QUERY_KEY_COLLECTION_ITEMS } from './useGetCollectionItems';

export const useCopyCard = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await metabaseApi.post(
        `${METABASE_API_URL}/card/${id}/copy`
      );
      return response;
    },
    onSuccess: () => {
      notify.default({
        title: intl.formatMessage(
          { id: 'features.reporting.duplicateNotification.itemDuplicated' },
          {
            itemType: intl.formatMessage({
              id: 'features.reporting.itemType.card',
            }),
          }
        ),
      });

      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_COLLECTION_ITEMS],
      });
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage(
          {
            id: 'features.reporting.duplicateNotification.itemDuplicationFailed',
          },
          {
            itemType: intl.formatMessage({
              id: 'features.reporting.itemType.card',
            }),
          }
        ),
      });
    },
  });
};
